<template>
  <div class="add-owner-view">
    <TopProgressBar v-if="isMobile" prevStep="partner-business" :is-back-shown="true"/>
    <div class="ob-step-container -helper--flex column">
      <div class="title">Add another owner</div>
      <v-form
        :class="'-helper--flex column'"
        id="v-form"
        ref="form"
        @submit.prevent="submitForm"
      >
        <div class="-helper--flex column form-wrapper-1">
        <label ref="ownerDetailsSection" class="form-section-header">Owner details</label>
       <div class="form-row">
          <v-text-field
            dense
            filled
            rounded
            validate-on-blur
            v-model="formData.firstName"
            autocomplete="null"
            type="text"
            v-on:focus="clearFieldError('firstName')"
            :rules="fieldRules.firstName"
            :error-messages="formFieldsErrors.firstName"
            id="firstName"
            ref="firstName"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('intro.firstName') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="firstNameMessage" v-html="message"></span>
            </template>
          </v-text-field>

          <v-text-field
            dense
            filled
            rounded
            validate-on-blur
            v-model="formData.lastName"
            autocomplete="null"
            v-on:focus="clearFieldError('lastName')"
            :rules="fieldRules.lastName"
            :error-messages="formFieldsErrors.lastName"
            id="lastName"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('intro.lastName') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="lastNameMessage" v-html="message"></span>
            </template>
          </v-text-field>
        </div>
        <div class="form-row">
          <v-text-field
            ref="phoneField"
            dense
            filled
            rounded
            validate-on-blur
            autocomplete="null"
            v-mask="'+1 (###) ###-####'"
            type="tel"
            v-model="formData.phoneNumber"
            v-on:focus="clearFieldError('phoneNumber')"
            :rules="fieldRules.phoneNumber"
            :error-messages="formFieldsErrors.phoneNumber"
            id="phoneNumber"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('register.label') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="phoneMessage" v-html="message"></span>
            </template>
          </v-text-field>

          <v-text-field
            dense
            filled
            rounded
            v-model="formData.email"
            :rules="fieldRules.email"
            :error-messages="formFieldsErrors.email || formFieldsErrors.defaultError"
            autocomplete="null"
            v-on:focus="clearFieldError('email')"
            type="email"
            validate-on-blur
            ref="emailInput"
            id="email"
            :disabled="!!uboId"
          >
            <template slot="label">
              {{ $t('intro.email') }}
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="emailMessage" v-html="message"></span>
            </template>
          </v-text-field>
        </div>
        <div class="horizontal-divider"></div>
        <label ref="ownerIdentitySection" class="form-section-header">Owner identity details</label>
        <div class="form-row">
          <div class="ssn">
            <v-text-field
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="null"
              v-mask="'###-##-####'"
              v-model="formData.ssn"
              v-on:focus="clearFieldError('ssn')"
              :type="flags.isSsnShown ? 'tel' : 'password'"
              :append-icon="flags.isSsnShown ? icons.mdiEyeInternal : icons.mdiEyeOffInternal"
              @click:append="flags.isSsnShown = !flags.isSsnShown"
              :rules="fieldRules.ssn"
              :error-messages="formFieldsErrors.ssn"
              id="ssn"
            >
              <template v-slot:label>
                <p class="input-legend">{{ $t('kyc.ssn') }}</p>
              </template>
              <template v-slot:message="{ message, key }">
                <span :key="key" id="ssnMessage" v-html="message"></span>
              </template>
            </v-text-field>
          </div>

          <v-text-field
            dense
            filled
            rounded
            validate-on-blur
            autocomplete="null"
            v-mask="'##/##/####'"
            type="tel"
            v-model="formData.birthDate"
            v-on:focus="clearFieldError('birthDate')"
            placeholder="MM/DD/YYYY"
            :rules="fieldRules.birthDate"
            :error-messages="
              formFieldsErrors.birthDate
            "
            id="birthDate"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('kyc.birthDate') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="birthDateMessage" v-html="message"></span>
            </template>
          </v-text-field>
        </div>
      </div>
      <div class="horizontal-divider"></div>
      <div>
      <div style="align-items: baseline" class="-helper--flex align-center space-between">
        <label ref="ownerAddressSection" class="form-section-header">Owner personal address</label>

        <div style="position: relative" class="-helper--flex align-center">
          <img v-if="formData.checkbox" class="checkbox-image" src="../RF_assets/icons/checkmark-lili-blue.svg" />
          <input id="elCheckBox" @change="handleCheck" class="checkbox" ref="elCheckbox" type="checkbox" v-model="formData.checkbox" />
          <p class="disclaimer">Same as mine</p>
        </div>
      </div>
        <div class="form-row">
        <div class="line1">
          <v-text-field
            dense
            filled
            rounded
            v-model="formData.line1"
            autocomplete="null"
            v-on:focus="clearFieldError('line1')"
            :rules="fieldRules.line1"
            :error-messages="
              formFieldsErrors.line1
            "
            id="line1"
            :disabled="formData.checkbox"
          >
            <template v-slot:label>
              <p class="input-legend">{{ $t('addressDetail.line1') }}</p>
            </template>
            <template v-slot:message="{ message, key }">
              <span :key="key" id="line1Message" v-html="message"></span>
            </template>
          </v-text-field>
        </div>

      <div class="form-row" >
        <v-text-field
          dense
          filled
          rounded
          autocomplete="null"
          v-model="formData.line2"
          v-on:focus="clearFieldError('line2')"
          :error-messages="formFieldsErrors.line2"
          id="line2"
          style="max-width: 48%"
          :disabled="formData.checkbox"
        >
          <template v-slot:label>
            <p class="input-legend" style="font-size: 13px;">{{ $t('addressDetail.line2') }}</p>
          </template>
          <template v-slot:message="{ message, key }">
            <span :key="key" id="line2Message" v-html="message"></span>
          </template>
        </v-text-field>

        <v-text-field
          v-if="isMobile"
          dense
          filled
          rounded
          autocomplete="null"
          :disabled="formData.checkbox"
          v-model="formData.postalCode"
          v-on:focus="clearFieldError('postalCode')"
          :rules="fieldRules.zip"
          :error-messages="formFieldsErrors.postalCode"
          inputmode="numeric"
          v-mask="'#####'"
          class="zip"
          id="postalCode"
          ref="postalCode"
        >
          <template v-slot:label>
            <p class="input-legend">
              {{ $t('addressDetail.postalCode') }}
            </p>
          </template>
          <template v-slot:message="{ message, key }">
            <span
              :key="key"
              id="postalCodeMessage"
              v-html="message"
            ></span>
          </template>
        </v-text-field>

        <v-text-field
          v-if="!isMobile"
          dense
          filled
          rounded
          autocomplete="null"
          v-model="formData.city"
          v-on:focus="clearFieldError('city')"
          :rules="fieldRules.city"
          :error-messages="formFieldsErrors.city"
          class="city"
          id="city"
          :disabled="formData.checkbox"
        >
          <template v-slot:label>
            <p class="input-legend">{{ $t('addressDetail.city') }}</p>
          </template>
          <template v-slot:message="{ message, key }">
            <span :key="key" id="cityMessage" v-html="message"></span>
          </template>
        </v-text-field>
      </div>
      <v-text-field
        v-if="isMobile"
        dense
        filled
        rounded
        autocomplete="null"
        v-model="formData.city"
        v-on:focus="clearFieldError('city')"
        :rules="fieldRules.city"
        :error-messages="formFieldsErrors.city"
        class="city"
        id="city"
        :disabled="formData.checkbox"
      >
        <template v-slot:label>
          <p class="input-legend">{{ $t('addressDetail.city') }}</p>
        </template>
        <template v-slot:message="{ message, key }">
          <span :key="key" id="cityMessage" v-html="message"></span>
        </template>
      </v-text-field>
    </div>


      <div class="-helper--flex align-center space-between relative">
        <div class="state relative" id="ubo-state">
          <v-select
            v-model="formData.state"
            :items="businessTypes"
            append-icon="mdi-chevron-down"
            :rules="fieldRules.state"
            :label="$t('addressDetail.state')"
            item-text="title"
            item-value="id"
            filled
            :disabled="formData.checkbox"
            >
            <template v-slot:item="data">
              <p class="v-list-item__title" :id="data.item.id">{{ data.item.title }}</p>
            </template>
          </v-select>
        </div>

        <v-text-field
          v-if="!isMobile"
          dense
          filled
          rounded
          autocomplete="null"
          :disabled="formData.checkbox"
          v-model="formData.postalCode"
          v-on:focus="clearFieldError('postalCode')"
          :rules="fieldRules.zip"
          :error-messages="formFieldsErrors.postalCode"
          inputmode="numeric"
          v-mask="'#####'"
          class="zip"
          id="postalCode"
          ref="postalCode"
        >
          <template v-slot:label>
            <p class="input-legend">
              {{ $t('addressDetail.postalCode') }}
            </p>
          </template>
          <template v-slot:message="{ message, key }">
            <span
              :key="key"
              id="postalCodeMessage"
              v-html="message"
            ></span>
          </template>
        </v-text-field>
      </div>
      <div class="horizontal-divider"></div>
      <div class="percentOwned">
        <v-text-field
            v-if="isSunriseFlow"
            dense
            filled
            rounded
            validate-on-blur
            autocomplete="null"
            v-model="formData.percentOwned"
            v-on:focus="clearFieldError('percentOwned')"
            :rules="fieldRules.percentOwned"
            :error-messages="formFieldsErrors.percentOwned"
            inputmode="numeric"
            v-mask="'##'"
            id="percentOwned"
            ref="percentOwned"
            :suffix="formData.percentOwned ? '%' : ''"
        >
          <template v-slot:label>
            <p class="input-legend">
              Ownership Percentage (%)
            </p>
          </template>
          <template v-slot:message="{ message, key }">
              <span
                  :key="key"
                  id="percentOwnedMessage"
                  v-html="message"
              ></span>
          </template>
        </v-text-field>
        </div>

        <div v-if="isMultiUserOnBoardingFeatureOpen" class="add-owner-ubo-container" data-testid="ubo-access-container-desktop">
          <div
            class='add-owner-ubo'
            :class="{
                'error': isUBOFieldInvalid(),
              }"
          >
            <h3 data-testid="ubo-access-title-desktop">{{ $t('add_owner_ubo.title') }}</h3>
            <div class='ubo-buttons-wrapper' data-testid="ubo-access-buttons-container-desktop">
              <v-btn
                class="ubo-button-yes"
                :class="{
                'is-active': isUBOPartnerFullAccess(),
              }"
                elevation="0"
                @click.prevent="updateRoleToPartnerFullAccess()"
                type="button"
                id="add-owner-ubo__yes"
              >
                {{ $t('add_owner_ubo.button_yes') }}
              </v-btn>
              <v-btn
                class="ubo-button-no"
                :class="{
                'is-active': isUBOPartner(),
              }"
                elevation="0"
                @click.prevent="updateRoleToPartner()"
                type="button"
                id="add-owner-ubo__no"
              >
                {{ $t('add_owner_ubo.button_no') }}
              </v-btn>
            </div>
          </div>
          <h3 v-if="isUBOFieldInvalid()" class="add-owner-ubo__error" data-testid="ubo-access-error-field-desktop">{{ $t('add_owner_ubo.required') }}</h3>
        </div>
      </div>
      <div class="horizontal-divider"></div>
      </v-form>


      <div class="action-wrapper">
        <h3
          v-if="!isMobile"
          @click="handleBack"
          class="form-footer-back -helper--flex align-center"
          id="elNavBackDesktop"
        >
          {{ $t('navBack') }}
        </h3>
        <v-btn
          class="main-app-cta margin-left-auto"
          :class="{
              'disabled-cta': false,
              'active-cta': true
            }"
          elevation="0"
          @click.prevent="submitForm"
          :loading="flags.isLoading"
          type="submit"
          id="elCta"
        >
          {{ $t('submit') }}
        </v-btn>
      </div>
      <MobileFooter v-if="isMobile"/>

    </div>
  </div>
</template>

<script>
import {params} from '../localData'
import moment from 'moment'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import {dataLayerHandler} from '../services/analyticsService'
import {formatDateToISO} from '../services/UtilService'
import {BANK_TYPES, UBORoles} from '../consts'
import { isMultiUserOnBoardingOpen } from '../consts/featureFlags'
import mixpanel from '../plugins/mixPanel'
import TopProgressBar from '../components/globalUiComponents/TopProgressController.vue'
import MobileFooter from '../components/globalUiComponents/MobileFooter.vue'
import { findAndScrollToFormError, scrollToServerErrorBySection } from '../services/entities/errorService'

export default {
  components: {
    TopProgressBar,
    MobileFooter
  },
  watch: {
    formData: {
      handler (data) {
        if (Number(data.percentOwned) > this.maxUboPercent) {
          this.formFieldsErrors.percentOwned = 'total ownership percentage exceeds 100%'
        } else {
          this.formFieldsErrors.percentOwned = ''
        }
      },
      deep: true
    }
  },
  mounted () {
    const {editRef} = this.$route.query
    if (editRef) {
      const refObject = this.customerData.businessOwners.find(i => i.externalId === editRef)
      if (refObject) {
        this.uboId = refObject.externalId
        this.formData = {
          checkbox: refObject.customerAddressData.sameAsPrimary,
          sameAsPrimary: refObject.customerAddressData.sameAsPrimary,
          firstName: refObject.firstName,
          lastName: refObject.lastName,
          phoneNumber: refObject.phoneNumber,
          email: refObject.email,
          line1: refObject.customerAddressData.line1,
          line2: refObject.customerAddressData.line2,
          state: refObject.customerAddressData.state,
          postalCode: refObject.customerAddressData.postalCode,
          city: refObject.customerAddressData.city,
          ssn: refObject.ssn,
          birthDate: moment.parseZone(refObject.birthDate).format('MM/DD/YYYY'),
          role: refObject.role,
          percentOwned: refObject.ownershipPercent
        }
        setTimeout(() => { this.$refs.firstName.focus() }, 500)
        setTimeout(() => { this.$refs.firstName.blur() }, 700)
      }
    }
    dataLayerHandler(
      this,
      'add-owner',
      'add-owner-screen-load',
      '',
      'screen load'
    )
  },
  computed: {
    isSunriseFlow () {
      return (this.customerData.institutionData && this.customerData.institutionData.bankType === BANK_TYPES.SUNRISE)
    },
    maxUboPercent () {
      const ownerPercent = Number(this.customerData.ownershipPercent)
      let sumOfOwnersPercent = 0
      this.customerData.businessOwners.forEach(owner => {
        if (owner.email !== this.formData.email) {
          sumOfOwnersPercent += owner.ownershipPercent
        }
      })
      return 100 - (ownerPercent + sumOfOwnersPercent)
    },
    isMobile () {
      return this.$store.getters['onboarding/isMobile']
    },
    isFormValid () {
      if (this.formData.checkbox && this.ownersList.length > 1) {
        return true
      } else {
        return false
      }
    },
    formFieldsErrors () {
      return this.$store.getters['errors/fieldErrors']
    },
    businessTypes () {
      return params.states
    },
    customerData () {
      return this.$store.getters['customer/data']
    },
    ajaxData () {
      const ajax = {
        method: 'post',
        endPoint: `v3/secureonboarding/partner/user/${this.customerData.customerId}/business/${this.customerData.businessId}/ubo`,
        data: {
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber
            .replace('+1', '')
            .replace(' ', ''),
          customerPersonalInfo: {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName
          },
          customerSSN: {
            ssn: this.formData.ssn.replaceAll('-', ''),
            birthDate: formatDateToISO(this.formData.birthDate)
          },
          customerAddress: {
            city: this.formData.city,
            state: this.formData.state,
            line1: this.formData.line1,
            line2: this.formData.line2,
            postalCode: this.formData.postalCode,
            sameAsPrimary: this.formData.sameAsPrimary
          },
          role: this.formData.role || 'PARTNER',
          ownershipPercent: this.isSunriseFlow ? this.formData.percentOwned : null
        },
        self: this
      }
      if (this.uboId) {
        ajax.data.externalId = this.uboId
      }
      return ajax
    },
    isMultiUserOnBoardingFeatureOpen () {
      return isMultiUserOnBoardingOpen
    }
  },
  methods: {
    async submitForm () {
      this.flags.wasContinueBtnClicked = true
      const isFormValid = this.$refs.form.validate() && !this.isUBOFieldInvalid()

      if (!isFormValid) return findAndScrollToFormError(this.$refs.form)
      try {
        this.flags.isLoading = true
        await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxData,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'lili ' + this.customerData.accessToken
            }
          },
          this
        )
        this.flags.isLoading = false
        this.$router.push('/partner/business')
      } catch (e) {
        scrollToServerErrorBySection(this.$refs, {
          ownerDetailsSection: ['firstName', 'lastName', 'phoneNumber', 'email'],
          ownerIdentitySection: ['ssn', 'birthDate'],
          ownerAddressSection: ['line1', 'line2', 'city', 'state', 'postalCode']
        }, e.field)
        this.flags.isLoading = false
      }
    },
    validateForm () {
      console.log(this.$refs.form.validate())
    },
    clearFieldError (field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [field])
    },
    handleCheck () {
      if (this.formData.checkbox) {
        this.formData.line1 = this.customerData.line1
        this.formData.line2 = this.customerData.line2
        this.formData.city = this.customerData.city
        this.formData.postalCode = this.customerData.postalCode
        this.formData.state = this.customerData.state
        this.formData.sameAsPrimary = true
      } else {
        this.formData.line1 = ''
        this.formData.line2 = ''
        this.formData.city = ''
        this.formData.postalCode = ''
        this.formData.state = ''
        this.formData.sameAsPrimary = false
      }
      this.clearFieldError('line1')
      this.clearFieldError('line2')
      this.clearFieldError('city')
      this.clearFieldError('postalCode')
      this.clearFieldError('state')
    },
    updateRoleToPartnerFullAccess () {
      this.formData.role = UBORoles.PARTNER_FULL_ACCESS
      mixpanel.track('Act on Add Owner', { grant_access_to_owner: 'Yes' })
    },
    updateRoleToPartner () {
      this.formData.role = UBORoles.PARTNER
      mixpanel.track('Act on Add Owner', { grant_access_to_owner: 'No' })
    },
    isUBOFieldInvalid () {
      return this.flags.wasContinueBtnClicked && this.formData.role === ''
    },
    isUBOPartnerFullAccess () {
      return this.formData.role === UBORoles.PARTNER_FULL_ACCESS
    },
    isUBOPartner () {
      return this.formData.role === UBORoles.PARTNER
    },
    handleBack () {
      this.clearFieldError('phoneNumber')
      this.$router.push({name: 'partner-business'})
    }
  },
  data () {
    return {
      localFormErrors: {state: ''},
      uboId: '',
      icons: {
        mdiEyeOffInternal: mdiEyeOffOutline,
        mdiEyeInternal: mdiEyeOutline
      },
      formData: {
        checkbox: false,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        line1: '',
        line2: '',
        state: '',
        postalCode: '',
        city: '',
        ssn: '',
        birthDate: '',
        sameAsPrimary: false,
        role: !isMultiUserOnBoardingOpen ? UBORoles.PARTNER : '',
        percentOwned: ''
      },
      flags: {
        isLoading: false,
        isSsnShown: true,
        isFormValid: false,
        wasContinueBtnClicked: false
      },
      fieldRules: {
        percentOwned: [v => !!v || 'Business percent is required',
          v => (v && Number(v) >= 25) || this.$t('validation.custom.percentOwned.min') ],
        firstName: [
          v => !!v || this.$t('validation.custom.firstName.required'),
          v =>
            (v && v.length > 1) || this.$t('validation.custom.firstName.min'),
          v =>
            (v && v.length < 30) || this.$t('validation.custom.firstName.max'),
          v =>
            /^[a-zA-Z-_ ]*$/.test(v) ||
            this.$t('validation.custom.firstName.regex')
        ],
        lastName: [
          v => !!v || this.$t('validation.custom.lastName.required'),
          v => (v && v.length > 1) || this.$t('validation.custom.lastName.min'),
          v =>
            (v && v.length < 30) || this.$t('validation.custom.lastName.max'),
          v =>
            /^[a-zA-Z-_ ]*$/.test(v) ||
            this.$t('validation.custom.lastName.regex')
        ],
        phoneNumber: [
          v => !!v || this.$t('validation.custom.phoneNumber.required'),
          v =>
            (v && v.length > 11) ||
            this.$t('validation.custom.phoneNumber.regex'),
          v =>
            /[0-9]+/.test(v) || this.$t('validation.custom.phoneNumber.regex')
        ],
        email: [
          // Indicate if the field value is falsey
          v => !!v || this.$t('validation.custom.email.required'),
          // Validate for an Email address scheme
          v =>
            /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(v) ||
            this.$t('validation.custom.email.email')
        ],
        ssn: [
          v => (v && v.length > 8) || this.$t('validation.custom.ssn.length')
        ],
        birthDate: [
          v => !!v || this.$t('validation.custom.birthDate.required'),
          v =>
            /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2})*$/.test(
              v
            ) || this.$t('validation.custom.birthDate.date_format')
        ],
        line1: [
          v => !!v || this.$t('validation.custom.line1.required'),
          v => (v && v.length > 1) || this.$t('validation.custom.line1.min'),
          v => (v && v.length <= 40) || this.$t('validation.custom.line1.max'),
          v =>
            /^[A-Za-z-0-9\s]+$/.test(v) ||
            this.$t('validation.custom.line1.regex')
        ],
        city: [
          v => !!v || this.$t('validation.custom.city.required'),
          v => (v && v.length > 1) || this.$t('validation.custom.city.min'),
          v => (v && v.length < 21) || this.$t('validation.custom.city.max'),
          v =>
            /^[A-Za-z\s]+$/.test(v) || this.$t('validation.custom.city.format')
        ],
        zip: [
          v => !!v || this.$t('validation.custom.postalCode.required'),
          v =>
            (v && v.length > 4) ||
            this.$t('validation.custom.postalCode.length')
        ],
        state: [v => !!v || 'State is required'],
        role: [
          v => !!v || this.$t('validation.custom.role.required')
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AddOwner.vue